import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from '../../next-seo.config';
import { CrossChainSwaps } from '../components/CrossChainSwaps';
import { routes } from '../utils/routes';

const CROSS_CHAIN_TITLE = 'Cross chain swaps | Matcha DEX aggregator';
const CROSS_CHAIN_DESCRIPTION =
  'Cross chain swaps let you move crypto tokens across chains in a single trade. Go where opportunity awaits with Matcha, the DEX aggregator from 0x!';

const CrossChainSwapsPage: NextPage = () => {
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={CROSS_CHAIN_TITLE}
        description={CROSS_CHAIN_DESCRIPTION}
        canonical={`${ROOT_URL_PRODUCTION}${routes.CROSS_CHAIN_SWAPS}`}
        openGraph={{
          images: [
            {
              url: `${ROOT_URL_PRODUCTION}/images/og/social-crosschain-banner.jpg`,
              width: 1200,
              height: 630,
              alt: 'Matcha',
            },
          ],
        }}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: CROSS_CHAIN_TITLE,
          },
          {
            name: 'twitter:description',
            content: CROSS_CHAIN_DESCRIPTION,
          },
          {
            name: 'twitter:image',
            content: `${ROOT_URL_PRODUCTION}/images/og/social-crosschain-banner.jpg`,
          },
          {
            name: 'twitter:url',
            content: `${ROOT_URL_PRODUCTION}${routes.CROSS_CHAIN_SWAPS}`,
          },
        ]}
      />
      <CrossChainSwaps />
    </>
  );
};

export default CrossChainSwapsPage;
